const actions = {
  getListagemEstoque: async (
    context,
    {
      per_page,
      vendor_id,
      page,
      search,
      categoria,
      conta_contabil,
      com_conta_contabil,
      grupo,
      contract_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/contracts/${contract_id}/products`, {
      params: {
        per_page,
        vendor_id,
        page,
        search,
        categoria,
        conta_contabil,
        com_conta_contabil,
        grupo,
      },
    });

    return res;
  },

  exportListagemEstoque: async (context, { contract_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/contracts/${contract_id}/products-export`);

    return res;
  },

  salvarRecurso: async (context, { product_id, vendor_id, conta_contabil }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.put(`/products/${product_id}/update-conta-contabil`, {
      conta_contabil,
      product_id,
      vendor_id,
    });

    return res;
  },
};

export const fiscalStore = {
  namespaced: true,
  actions,
};
